import { ApiService } from '../model/Api.model';
import { AxiosInstance } from 'axios';
import { IFillSelect } from '../interface/generic/IFillSelect';

enum CourtTypeAccrualTypeEnum {
	getTypes = '/types?idCourtType=',
}

export default class CourtTypeAccrualTypeService extends ApiService {
	constructor(restClient: AxiosInstance) {
		super(restClient, '/court-type/accrual-type');
	}
	public getTypes = async (idCourtType: number): Promise<IFillSelect[]> => await this.GET(CourtTypeAccrualTypeEnum.getTypes + idCourtType);
}
